import { Cirus } from "@/classes/Http";

enum InvoiceType {
    SOLD = "sold",
    BOUGHT = "bought",
    INCOME = "income",
    COST = "cost",
    RETURN_FROM_SOLD = "rs",
    RETURN_FROM_BOUGHT = "rb",
    TRANSFER = "transfer"
}

enum TransactionUserType {
    CUSTOMER = "0",
    USER = "1"
}

enum DeliveryType {
    INSTANCE_DOOR = 0,
    CUSTOMER_DOOR = 1,
    THIRD_PERSON = 2
}
enum DeliveryStatus {
    IN_INVENTORY = 0,
    SENDING = 1,
    SENT = 2,
    DELIVERED = 3,
    RETURNED = 4
}

class TransactionOption {
    id: string;
    category_filter_id: string;
}

class InvoiceTransaction {
    name: string;
    count: number;
    value: number;
    value_without_off: number = null;
    price_id: string;
    creator_type: TransactionUserType;
    creator_id: string;
    inventory_id: string = null;
    options: TransactionOption[];
    product_id: string;
    type: InvoiceType.SOLD = InvoiceType.SOLD;
}

class Payment {
    Amount = 0;
    paid = false;
}

class Position {
    latitude: string;
    longitude: string;
  }

class Location {
    countryId: number;
    stateId: number;
    cityId: number;
    verbal: string;
}

class Address {
    location: Location;
    position: Position;
    id_card: string;
    mobile: string;
    phone: string;
    postcode: string;
    receiver_name: string;
}

class InstanceDelivery {
    status: DeliveryStatus;
    total: number;
    type: DeliveryType;
    address: Address;
}


export class PublishInstanceSoldInvoiceBody {
    customer_id: string;
    title: string;
    description: string;
    type: InvoiceType.SOLD = InvoiceType.SOLD;
    transactions: InvoiceTransaction[];
    delivery: InstanceDelivery;
    payment: Payment;
    draft = false;
    total = 0;
}

export function publishInstanceSoldInvoice(instance_id: number, params: PublishInstanceSoldInvoiceBody) {
    const path = `/instance/${instance_id}/invoice-sold/publish`;
    return Cirus.post(path, params);
}